import React, { Component } from 'react'
import { observer } from 'mobx-react'
import PropTypes from 'prop-types'
import { tokenStorage } from '@atheneum/api/dist/lib'

class Actions extends Component {
  static propTypes = {
    startDate: PropTypes.string,
    endDate: PropTypes.string
  }

  render () {
    const { startDate, endDate } = this.props
    const token = tokenStorage.get()
    return (
      <ul className='actions right-list'>
        <li className='action'>
          <a
            onClick={e => e.stopPropagation()}
            href={
              '/api/payment?startDate=' +
              startDate +
              '&endDate=' +
              endDate +
              '&token=' +
              token
            }
            target='_blank'
            download rel="noreferrer"
          >
            <span>Export</span>
          </a>
        </li>
      </ul>
    )
  }
}

export default observer(Actions)
